import { IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { FunctionComponent } from 'react';
import { getHeightMegduSlov, selectTheme } from '../../utils/utils';

interface Props {
  curTheme: number;
  textColor: string;
  title: string;
  fontSize: string;
  onClose: () => void;
}

export const DialogHeaderDiv: FunctionComponent<Props> = ({
  curTheme,
  textColor,
  title,
  fontSize,
  onClose,
}) => (
  <div>
    <Stack direction="row" alignItems="flex-start">
      <Typography
        style={{
          fontFamily: 'sans-serif',
          fontSize,
          textAlign: 'left',
          width: '100%',
          fontWeight: '400',
          wordWrap: 'break-word',
          color: selectTheme(textColor, curTheme, -1),
          lineHeight: getHeightMegduSlov(fontSize),
        }}
        component="text"
      >
        {title}
      </Typography>
      <IconButton size="small" onClick={onClose}>
        <CloseIcon
          fontSize="small"
          sx={{ color: selectTheme(textColor, curTheme, -1) }}
        />
      </IconButton>
    </Stack>
  </div>
);
